import { Fragment, useState, useEffect } from 'react'
import ReviewAddContainer from './ReviewAddContainer'

const ReviewAddButton = ({ onClick, direction, isActive }) => {
  const handleClick = () => {
    onClick(direction, !isActive)
  }

  return (
    <button
      className={`reviews__button ${isActive ? 'active' : ''}`}
      onClick={handleClick}
    >
      <i className={`font-icons icon-thumbs-${direction}-new`} />
    </button>
  )
}

export const ReviewAddButtons = () => {
  const [isCollapsed, setCollapsed] = useState(false)
  const [btnsState, setBtnsState] = useState({})

  const handleAddingReview = (buttonKind, isActive) => {
    setBtnsState({ [buttonKind]: isActive })
  }

  useEffect(() => {
    setCollapsed(btnsState.up || btnsState.down)
  }, [btnsState])

  const handleModalClose = () => {
    setBtnsState({})
    setCollapsed(false)
  }

  return (
    <Fragment>
      <div className='reviews__buttons'>
        <ReviewAddButton
          onClick={handleAddingReview}
          isActive={btnsState.up}
          direction='up'
        />
        <ReviewAddButton
          onClick={handleAddingReview}
          isActive={btnsState.down}
          direction='down'
        />
      </div>
      <ReviewAddContainer
        isPositive={btnsState.up}
        isOpen={isCollapsed}
        afterSubmit={handleModalClose}
      />
    </Fragment>
  )
}
